import { render, staticRenderFns } from "./workspace-library-receiver-group-view.vue?vue&type=template&id=25da1480"
import script from "./workspace-library-receiver-group-view.vue?vue&type=script&lang=js"
export * from "./workspace-library-receiver-group-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports